import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { selectObjects } from "~/misc/common";

export default class extends Controller {
  connect() {
    console.log('initBookRequestForm');
    let last_book_id = $('#book_request_book_id').myGetNumValue();
    const books = $('#toJs').data('books');
    refresh();
    $('#book_request_book_id').on('change', refresh);

    function refresh() {
      const book_id = $('#book_request_book_id').myGetNumValue();
      if (book_id) {
        $('.book_request_book_count').show(400);
        $('.book').show(400);
        const book = selectObjects(books, 'id', $('#book_request_book_id').myGetNumValue())[0];
        $('.book .img img').attr("src", book.image_url);
        $('.book .publisher').text(book.publisher_name);
        $('.book .title').text(book.title_w_comment);
        $('.book .codeval').text(book.publisher_code);
      } else {
        $('.book_request_book_count').hide(400);
        $('.book').hide(400);
        $('#book_request_book_count').val('');
      }
      last_book_id = book_id;
    }
  }
}
